import { useAuthenticated } from "nate-react-api-helpers";
import { useLocation } from "react-router-dom";
import { Login } from "./Login";
import Modal from "@mui/material/Modal";
import { jsx as _jsx } from "react/jsx-runtime";
export function RequireLogin() { var authenticated = useAuthenticated().authenticated; var location = useLocation(); if (authenticated)
    return null; switch (location.pathname) {
    case "/login":
    case "/forgot-password": return null;
    default: if (location.pathname.startsWith("/reset-password/"))
        return null;
} return /*#__PURE__*/ _jsx(Modal, { open: true, children: /*#__PURE__*/ _jsx(Login, {}) }); }
